"use client"

import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"

const DailyReportFilter = ({companies, handleDateChange, handleCompanyChange}) => {
  const [selectedDate, setSelectedDate] = useState();
  const [selectedSecCode, setSelectedSecCode] = useState({'all': 'ALL'});
  const modifiedCompanies = [{sec_code: 'all', company_name: 'ALL'}, ...companies];
  const onDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月は0から始まるため+1
      const day = ('0' + date.getDate()).slice(-2);
      const formattedDate = `${year}-${month}-${day}`;
      handleDateChange(formattedDate);
    } else {
      handleDateChange(null);
    }
  }

  const onCompanyChange = (secCode) => {
    setSelectedSecCode(secCode);
    handleCompanyChange(secCode);
  }
  
  return (
    <div className="filter-area">
      <div className="filter-by-date">
        <label htmlFor="date-picker" className="filter-date-label">日付を指定</label>
        <DatePicker
          id="date-picker"
          selected={selectedDate}
          onChange={(date) => onDateChange(date)}
          dateFormat="yyyy/MM/dd"
          className="border border-gray-300 rounded px-2 py-1"
          placeholderText="日付を選択"
        />
      </div>
      <div className="filter-by-company">
        <label htmlFor="company-select" className="w-24">企業を指定</label>
        <select
          id="company-select"
          value={selectedSecCode}
          onChange={(e) => onCompanyChange(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1"
        >
          {modifiedCompanies.map((company) => (
            <option key={company.sec_code} value={company.sec_code}>
              {company.company_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default DailyReportFilter